var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { Observable } from '../../Observable/Observable';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
let ValidationRepository = class ValidationRepository {
    constructor(apiDataSource) {
        this.apiDataSource = apiDataSource;
        this.validations = new Observable({});
    }
    preload() {
        const params = {
            path: 'validations'
        };
        return this.apiDataSource.get(params)
            .then(({ data }) => {
            const validations = data.reduce((acc, validation) => {
                acc[validation.path] = validation.fields.reduce((fieldsAcc, field) => {
                    fieldsAcc[field.name] = field;
                    return fieldsAcc;
                }, {});
                return acc;
            }, {});
            return this.validations.next(validations);
        });
    }
    get(path) {
        return this.validations.value[path];
    }
};
ValidationRepository = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IAPIHTTPDataSourceType)),
    __metadata("design:paramtypes", [Object])
], ValidationRepository);
export { ValidationRepository };
